<template>
<DialogFrame :show-dialog="show"
             :on-click-close="close"
             :title="'支店側で承認するスタッフ一覧'"
             :height="'90%'"
             :width="'90%'">
    <template v-slot:dialogContent>
        <div class="container content-frame">
            <div class="row list-table-row">
                <div class="col table-wrap">
                    <table v-if="affectedList.length > 0"
                           class="table">
                        <thead>
                            <tr>
                                <th>スタッフID</th>
                                <th>スタッフ名</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="staff in affectedList"
                                :key="staff.vForKey">
                                <td>{{ staff.staffId }}</td>
                                <td>{{ staff.displayName }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else
                         class="empty-table-text wrap-text"
                         :style="{fontSize: FontSizes.large1}">支店による一斉承認を行うスタッフはいません</div>
                </div>
            </div>
            <div class="row button-row justify-content-md-end">
                <button class="btn btn-outline-info col col-md-4 align-self-center mx-1"
                        @click="close">キャンセル</button>
                <button class="btn btn-info col col-md-4 align-self-center mx-1"
                        @click="onClickApproveByBranch"
                        :disabled="!canClickApprovalByBranch()">承認する</button>
            </div>
        </div>
    </template>
</DialogFrame>
</template>

<script lang="ts">
import {defineComponent, PropType, ref, watch} from "vue";
import DialogFrame from "@/components/DialogFrame.vue";
import {amountToString} from "@/utils/string-utils";
import {backendApi} from "@/utils/backend-api";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {FontSizes} from "@/utils/font-sizes";
import {Staff} from "@/data-models/staff";
import {logoutMessages, subPaths} from "@/utils/consts";
import {useRouter} from "vue-router";

export default defineComponent({
    name: "BranchApprovalAffectedListDialog",
    components: {
        DialogFrame,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        close: {
            type: Function as PropType<() => void>,
            required: true
        },
        branchName: {
            type: String,
            required: true,
        },
        onFinishApproval: {
            type: Function as PropType<() => void>,
            required: true,
        }
    },
    setup(props) {

        const affectedList = ref<Staff[]>([] as Staff[])

        const router = useRouter()

        const update = async () => {
            const resp = await backendApi.inquireAffectedListByBranchConfirm(props.branchName)

            if (resp.isAuthorized) {
                affectedList.value = Staff.fromJsonArrToArr(resp.value)
                console.log(affectedList.value)
            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        watch(() => props.show, async () => {
            if (props.show) {
                await update()
            }
        })

        const onClickApproveByBranch = async () => {
            const resp = await backendApi.inquireApproveByBranch(props.branchName)
            if (resp.isAuthorized) {
                props.onFinishApproval()
            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        const canClickApprovalByBranch = (): boolean => {
            return affectedList.value.length > 0
        }

        return {
            affectedList,
            onClickApproveByBranch,
            canClickApprovalByBranch,
            FontSizes,
        }
    }
})
</script>

<style scoped lang="scss">

.content-frame {
    //background-color: red;
    height: 100%;

    .list-table-row {
        height: calc(100% - 50px);
        //background-color: blue;

        .table-wrap {

            height: 100%;
            //background-color: burlywood;
            overflow: auto;

            .table {
                thead th {
                    position: sticky;
                    top: 0;
                    z-index: 1;
                    background-color: whitesmoke;
                    box-shadow: 1px 1px 3px #AAA;
                }
            }

            .empty-table-text {
                color: lightgray;
            }

        }
    }

    .button-row {
        height: 50px;
        //background-color: yellow;

        button {
            height: 40px;
        }
    }

}



</style>